import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatTooltipTruncateDirective } from '@examdojo/core/mat-tooltip-truncate';
import { MatTooltip } from '@angular/material/tooltip';
import { BaseCellRendererComponent } from '@examdojo/ag-grid';
import {
  getReferenceQuestionStatusClassName,
  getReferenceQuestionStatusLabel,
  ReferenceQuestionViewStoreModel,
} from '@examdojo/reference-question';
import { ReferenceQuestionStatus } from '@examdojo/review';

@Component({
  selector: 'exam-reference-question-list-status-cell-renderer',
  template: `
    @if (status) {
      <div
        [ngClass]="statusClass"
        class="inline-flex max-w-full overflow-hidden rounded-[6px] px-1.5 py-1 text-xs font-semibold"
      >
        <span class="truncate" [matTooltip]="statusLabel">{{ statusLabel }}</span>
      </div>
    }
  `,
  imports: [MatTooltipTruncateDirective, MatTooltip, NgClass],
})
export class ReferenceQuestionListStatusCellRendererComponent extends BaseCellRendererComponent<
  ReferenceQuestionStatus | null,
  ReferenceQuestionViewStoreModel
> {
  get status(): ReferenceQuestionStatus | null {
    return this.params?.data?.status ?? null;
  }

  get statusClass(): string {
    return getReferenceQuestionStatusClassName(this.status);
  }

  get statusLabel(): string {
    return getReferenceQuestionStatusLabel(this.status);
  }
}
